import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../const.js";

import InputText from "../InputText/InputText";
import InputDate from "../InputDate/InputDate";
import InputAdress from "../InputAdress/InputAdress";
import InputFile from "../InputFile/InputFile";
import InputTextarea from "../InputTextarea/InputTextarea";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import PrewButton from "../PrewButton/PrewButton";
import NextButton from "../NextButton/NextButton";

function Step1(props) {
  const {
    setStep,
    name,
    setName,
    surname,
    setSurname,
    patronymic,
    setPatronymic,
    experience,
    setExperience,
    birthDate,
    setBirthDate,
    address,
    setAddress,
    phone,
    setPhone,
    job,
    setJob,
    email,
    setEmail,
    participantPhoto,
    setParticipantPhoto,
    education,
    setEducation,
    languages,
    setLanguages,
    dataAgreement,
    setDataAgreement,
  } = props;

  const [isFormFilled, setIsFormFilled] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();

    const url = `${apiUrl}first_step/`;

    const data = {
      name: name,
      f_name: surname,
      middle_name: patronymic,
      work_experience: experience,
      date_of_birth: birthDate,
      address: address.value,
      place: job,
      email: email,
      phone: phone,
      photo_link: participantPhoto,
      education: education,
      lang: languages,
      participation: dataAgreement,
    };

    axios
      .post(url, data)
      .then((res) => {
        setStep(2);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          if ("non_field_errors" in error.response.data) {
            setStep(5);
            return;
          }

          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    setIsFormFilled(
      name &&
        surname &&
        patronymic &&
        experience &&
        birthDate &&
        address &&
        phone &&
        job &&
        email &&
        participantPhoto &&
        education &&
        languages &&
        dataAgreement
    );
  }, [
    name,
    surname,
    patronymic,
    experience,
    birthDate,
    address,
    phone,
    job,
    email,
    participantPhoto,
    education,
    languages,
    dataAgreement,
  ]);

  useEffect(() => {
    if (formErrors) {
      const firstError = Object.keys(formErrors)[0];
      const firstErrorInput = document.querySelector(`[name=${firstError}]`);

      firstErrorInput.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, [formErrors]);

  return (
    <form action="." onSubmit={submitHandler}>
      <div className="mm-form__inner">
        <InputText
          title="Имя *"
          placeholder="Иван"
          value={name}
          onChange={setName}
          error={formErrors?.name}
          name="name"
        />
        <InputText
          title="Фамилия *"
          placeholder="Иванов"
          value={surname}
          onChange={setSurname}
          error={formErrors?.f_name}
          name="f_name"
        />
        <InputText
          title="Отчество *"
          placeholder="Иванович"
          value={patronymic}
          onChange={setPatronymic}
          error={formErrors?.middle_name}
          name="middle_name"
        />
        <InputText
          title="Общий стаж работы*"
          placeholder="5 лет"
          value={experience}
          onChange={setExperience}
          error={formErrors?.work_experience}
          name="work_experience"
        />
        <InputDate
          title="Дата и год рождения *"
          placeholder="01.01.1990"
          mask="99.99.9999"
          value={birthDate}
          onChange={setBirthDate}
          error={formErrors?.date_of_birth}
          name="date_of_birth"
        />
        <InputAdress
          title="Адрес регистрации *"
          placeholder="Текст"
          value={address}
          onChange={setAddress}
          error={formErrors?.address}
          name="address"
        />
        <InputDate
          title="Телефон *"
          placeholder="+7 999 000 00 00"
          mask="(+7) 999 999 9999"
          type="tel"
          value={phone}
          onChange={setPhone}
          error={formErrors?.phone}
          name="phone"
        />
        <InputText
          title="Место работы *"
          placeholder='ООО "Название компании"'
          value={job}
          onChange={setJob}
          error={formErrors?.place}
          name="place"
        />
        <InputText
          title="E-mail *"
          placeholder="hello@gmail.com"
          type="email"
          value={email}
          onChange={setEmail}
          error={formErrors?.email}
          name="email"
        />
        <InputFile
          title="Фотография участника *"
          subTitle="Выберите файл или вставьте ссылку"
          placeholder="Выберите файл или вставьте ссылку"
          value={participantPhoto}
          onChange={setParticipantPhoto}
          error={formErrors?.photo_link}
          name="photo_link"
        />
        <InputTextarea
          title="Сведения об образовании и повышении квалификации *"
          subTitle="Учебное заведение, годы обучения, специальность"
          placeholder="Текст"
          onChange={setEducation}
          value={education}
          maxlength={3500}
          error={formErrors?.education}
          name="education"
        />
        <InputTextarea
          title="Владение иностранными языками *"
          subTitle="Уровень знания и практики применения в работе"
          placeholder="Текст"
          value={languages}
          onChange={setLanguages}
          maxlength={1500}
          error={formErrors?.lang}
          name="lang"
        />
        <InputCheckbox
          title="Обработка моих персональных данных производится Комитетом по туризму города Москвы в соответствии с требованиями Федерального закона от 27 июля 2006 №152-ФЗ «О персональных данных» (далее – Федеральный закон №152-ФЗ)"
          value={dataAgreement}
          onChange={setDataAgreement}
          name="participation"
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton isHidden={true} />
        <NextButton type="submit" disabled={!isFormFilled} />
      </div>
    </form>
  );
}

export default Step1;
